module.exports = __webpack_public_path__ + "static/img/wavm8s-019-yajo.dc36cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-019-yajo.png
// module id = 0bKP
// module chunks = 0